import { render, staticRenderFns } from "./PropertyAreaDetail.vue?vue&type=template&id=5c28894d"
import script from "./PropertyAreaDetail.vue?vue&type=script&lang=js"
export * from "./PropertyAreaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports